import { render, staticRenderFns } from "./OrganizationsView.vue?vue&type=template&id=ef1f9d1e&scoped=true&"
import script from "./OrganizationsView.vue?vue&type=script&lang=js&"
export * from "./OrganizationsView.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationsView.vue?vue&type=style&index=0&id=ef1f9d1e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef1f9d1e",
  null
  
)

export default component.exports